module.exports = __webpack_public_path__ + "resources/img/img_hacking_testing2_m_en.2b8bb2df043122ab76131e9920c0832f.png";